import {
  ChatMessageAttachments,
  type ChatMessageAttachment,
} from "../ChatMessageAttachments";
import type { ChatMessage } from "../types";
import type { ConversationVisibility } from "@/services/supportTicketService";

export interface SupportTicketMessageLike {
  id: string;
  content: string;
  is_from_admin: boolean;
  visibility: ConversationVisibility;
  created_at: string;
  sender_name?: string | null;
  attachments: ChatMessageAttachment[];
}

export type SupportTicketChatPerspective = "seller" | "admin";

export function mapSupportTicketMessageToChatMessage(
  message: SupportTicketMessageLike,
  options: {
    perspective: SupportTicketChatPerspective;
    labels: {
      internalNote: string;
      supportTeam: string;
      you: string;
      sellerFallback: string;
    };
  },
): ChatMessage {
  const { perspective, labels } = options;

  if (message.visibility === "ADMIN_ONLY") {
    return {
      id: message.id,
      content: message.content,
      createdAt: message.created_at,
      role: "notice",
      senderLabel: labels.internalNote,
    };
  }

  const isOwn =
    perspective === "seller"
      ? !message.is_from_admin
      : message.is_from_admin;

  const senderLabel = message.is_from_admin
    ? labels.supportTeam
    : perspective === "seller"
      ? labels.you
      : message.sender_name || labels.sellerFallback;

  const attachmentFooter =
    message.attachments.length > 0 ? (
      <ChatMessageAttachments
        attachments={message.attachments}
        align={isOwn ? "end" : "start"}
      />
    ) : undefined;

  return {
    id: message.id,
    content: message.content,
    createdAt: message.created_at,
    role: isOwn ? "self" : "other",
    senderLabel: isOwn ? undefined : senderLabel,
    showReadReceipt: isOwn,
    footer: attachmentFooter,
  };
}
